import React from 'react';

const SearchBox = () => <div data-adb-component="appdirectUniversalSearch" className="appdirectUniversalSearch"></div>;

export default SearchBox;
